import { useEffect } from "react";
import style from './Progress.module.css'
const Progress=({detail,elm,ren,setRen})=>{
    useEffect(()=>{
        setRen(true);
    },[setRen])
    return(
        <>
        <div className={style.detail}>
        <h3>Progress Report</h3>
        <div className="row">
          <h4 className="col-6 mb-2">Name :<span> {detail.FirstName} {detail.LastName} </span></h4>
          <h4 className="col-6 mb-2">Age :<span> {detail.Age}</span> </h4>
          <h4 className="col-6 mb-2">Marks :<span> {detail.Marks}</span></h4>
          <h4 className="col-6 mb-2">Contact:<span> {detail.Contact}</span> </h4>
        </div>
        <div className={style.progress_bar}>
            <div className={style.progress_level}>
                <div className={style.progress_line} style={(ren)?{width:`${detail.Marks}%`}:{width:"0"}} ref={elm}></div>
            </div>
          </div>
      </div> 
        </>
    )
}
export default Progress;